<template>
  <b-nav v-if="navPermissions['reports'].enable">
    <b-nav-item-dropdown
        id="my-nav-dropdown "
        text="Reports"
        toggle-class="nav-link-custom"
    >
      <template slot="button-content">
        <i class="fa mr-2 fa-file-invoice text-danger" font-scale="1"></i>
        <span>Reports</span>
      </template>
      <b-dropdown-item to="/reports">
        <i class="fa fa-industry text-primary" font-scale="1"></i>
        Dashboard
      </b-dropdown-item>
    </b-nav-item-dropdown>
  </b-nav>
</template>
<script>
import initService from "@/common/api-services/init-service";

export default {

  name: 'top-reports-group',
  components: {},

  data() {
    return {
      isPortalAdminStatus: false,
      isAdminStatus: false,
      groups: [],
      navPermissions: {
        "reports": {
          enable: false,
          role: ["REPORTS_READ", "Administrator"]
        }
      }
    }
  },
  mounted() {
    this.isPortalAdminStatus = initService.getPortalAdminRole();
    this.isAdminStatus = initService.getAdministratorRole() || initService.getPortalAdminRole();
    this.groups = initService.getGroups();
    Object.keys(this.navPermissions).map(item => {
      this.groups.map(it => {
        if (this.navPermissions[item].role.includes(it)) this.navPermissions[item].enable = true;
      });
    });
  }
}
</script>